import { useAsyncExecutor2 } from "async-executor-hook";
import { Message } from "primereact/message";
import { useEffect, useReducer } from "react";
import {
  ControlErrors,
  FormControl,
  FormGroup,
  useFormConfig,
  Validators,
  WForm,
  WFormControl,
} from "rectangular-forms";
import {
  BehaviorSubject,
  catchError,
  debounceTime,
  from,
  map,
  of,
  switchMap,
  tap,
} from "rxjs";

import {
  inputMaxLengthFn,
  onlyDigitsNumbers,
  WInputText,
  WInputTextArea,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import Modal from "../../Modal/Modal";
import {
  ApproveCompensationButton,
  ErrorMessage,
} from "../AdminPaymentValidationStatesSidebarStyles";
import { Container } from "./compensationCodeStyles";

const operationCompensationCode = (forceUpdate) => (control) => {
  const subject = new BehaviorSubject("");
  subject.next(control.value);
  const debouncerTime$ = subject.asObservable().pipe(
    debounceTime(1000),
    switchMap((data) => {
      const params = {
        compensation_code: data,
      };

      return from(
        networkBackendRequest(
          "/compensation-code/",
          HTTP_METHODS.GET,
          params,
          undefined
        ).then((resp) => resp.json())
      ).pipe(
        map((resp) => {
          return !resp.is_valid ? { codeConpensation: resp.is_valid } : null;
        }),
        tap(
          () => {
            setTimeout(() => {
              forceUpdate();
            }, 10);
          },
          () => {}
        ),
        catchError(() => {
          return of({ error: true });
        })
      );
    })
  );
  return debouncerTime$;
};
export const CompensationCode = (props) => {
  const { toggleModal, onSuccessData, sidebarInfo, onErrorData } = props;
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const asyncExecutor = useAsyncExecutor2(
    (comment: any) => {
      const data = {
        compensation_code: comment.code,
        compensation_comment: comment.comment,
      };
      return from(
        networkBackendRequest(
          `/invoices/upfront-manual/${comment.info.invoiceId}/cashback-status/`,
          HTTP_METHODS.PATCH,
          null,
          data
        ).then((resp) => resp.json())
      );
    },
    {
      onSuccess: () => {
        onSuccessData();
      },
      onError: (err) => {
        onErrorData(err);
      },
    }
  );

  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        code: new FormControl(
          null,
          [Validators.required, Validators.maxLength(30)],
          operationCompensationCode(forceUpdate)
        ),
        comment: new FormControl(),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      asyncExecutor.execute({
        code: form.value.code,
        comment: form.value.comment,
        info: sidebarInfo,
      });
    },
  });

  const { loadSucceed } = formConfig;

  useEffect(() => {
    loadSucceed({ code: "", comment: "" });
  }, [loadSucceed]);

  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <Container>
        <h1>Código de compensación</h1>
        <div style={{ width: "100%" }}>
          <WForm formConfig={formConfig} style={{ width: "100%" }}>
            <WFormControl
              name="code"
              errorMessages={{
                required: "Campo requerido",
                maxlength: "Maximo 30 caracteres",
              }}
            >
              <WInputText
                width="100%"
                height="5rem"
                placeholder="Ingresar código de compensación con SAP"
                onKeyPress={onlyDigitsNumbers}
                maxLength={30}
              />
              <ControlErrors>
                {(message) => {
                  return message === "codeConpensation" ? (
                    <ErrorMessage style={{ width: "100%" }}>
                      <label htmlFor="test">
                        Código de compensación ya existe.
                      </label>
                    </ErrorMessage>
                  ) : (
                    <Message
                      severity="error"
                      text={message}
                      style={{ position: "relative" }}
                    ></Message>
                  );
                }}
              </ControlErrors>
            </WFormControl>

            <WFormControl name="comment">
              <TemplateInputContainer
                color="rgba(46, 53, 61, 0.3)"
                marginBottom="0px"
                label={"Comentario:"}
                marginTop="2rem"
              >
                <WInputTextArea
                  maxWidth="38rem"
                  maxheight="15rem"
                  width="100%"
                  height="13.8rem"
                  placeholder="Escribe el motivo de aprobación"
                  rows={5}
                  cols={30}
                  maxLength={300}
                  onInput={inputMaxLengthFn}
                />
              </TemplateInputContainer>
            </WFormControl>
            <div style={{ marginTop: "4.2rem", width: "100%" }}>
              <ApproveCompensationButton
                type="submit"
                width="100%"
                disabled={!formConfig?.form?.valid || asyncExecutor.isLoading}
              >
                Realizar compensación
              </ApproveCompensationButton>
            </div>
          </WForm>
        </div>
      </Container>
    </Modal>
  );
};
